import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import StudentInfoPage from './pages/StudentInfoPage';
import PhoneVerificationPage from './pages/PhoneVerificationPage';
import VerificationCompletePage from './pages/VerificationCompletePage';
import HistoryPage from './pages/HistoryPage';
import LoginPage from './pages/login';
import FaceVer from './pages/FaceVer';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/mpbind/student-info" replace />} />
        <Route path="/mpbind/student-info" element={<StudentInfoPage />} />
        <Route path="/mpbind/phone-verification" element={<PhoneVerificationPage />} />
        <Route path="/mpbind/complete" element={<VerificationCompletePage />} />
        <Route path="/system" element={<HistoryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/mpbind/facever" element={<FaceVer />} />
      </Routes>
    </Router>
  );
}

export default App;